module.exports = __webpack_public_path__ + "media/images/pic/hero/courses/online/preschool-f5d4fff90fd4ffb069e5078a77168b73.jpeg";